import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { SxProps, styled } from '@youhelp-ru/ui';
import CornerChatBubblesSvg from 'src/assets/shapes/cornerChatBubbles.svg';
import { useIsIOS } from 'src/shared/mediaQueries';
import { RoutedLink } from 'src/shared/ui/link';

const Root = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: `${theme.borderRadius.medium}px`,
  border: `1px solid ${theme.palette['gray middle']}`,
  boxShadow: '14px 17px 40px 4px rgba(138, 182, 209, 0.08)',
  background: 'linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 60%, #FEDCDA 100%)',
  padding: theme.spacing(2.5),
}));

export const CatalogBannerSocialRanking: React.FC<{ sx?: SxProps }> = ({ sx }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const isIOS = useIsIOS();

  const appStoreHref = isMobile
    ? 'itms-apps://apps.apple.com/ru/app/youhelp/id1536935575'
    : 'https://apps.apple.com/ru/app/youhelp/id1536935575';
  const playStoreHref = isMobile ? 'market://details?id=ru.youhelp.app' : 'https://play.google.com/store/apps/details?id=ru.youhelp.app';
  const downloadHref = isIOS ? appStoreHref : playStoreHref;

  return (
    <Root sx={sx}>
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          right: 0,
          top: 0,
          width: 140,
          height: 142,
          pointerEvents: 'none',
          lineHeight: 0,
          '& svg': { display: 'block', width: '100%', height: '100%' },
        }}
      >
        <CornerChatBubblesSvg />
      </Box>

      <Stack gap={1} sx={{ position: 'relative', zIndex: 1 }}>
        <Typography component="div" sx={{ width: { xs: '70%', lg: '95%' } }} variant="h3">
          Более общительные кандидаты теперь{' '}
          <Box component="span" sx={{ color: theme.palette['brand pink'] }}>
            выше в поиске
          </Box>
        </Typography>

        <Typography component="div" sx={{ color: theme.palette['gray'] }} variant="caption">
          Сначала показываем тех, кто чаще отвечает работодателям.
        </Typography>

        <Typography component="div" variant="caption">
          Скачайте мобильное приложение и включите уведомления, чтобы не пропускать заказы.
        </Typography>

        <RoutedLink
          external
          href={downloadHref}
          size="small"
          sx={{
            mt: 1.5,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 1,
            borderRadius: `${theme.borderRadius.small}px`,
            border: `1px solid ${theme.palette['brand pink']}`,
            backgroundColor: theme.palette.white,
          }}
          underline={false}
        >
          Скачать приложение
        </RoutedLink>
      </Stack>
    </Root>
  );
};
